"use strict";

var _require = require('./Component'),
    ReactInterval = _require.ReactInterval;

ReactInterval.ReactInterval = ReactInterval;
module.exports = ReactInterval;